import request from '@/api'

// 通用API生成器
export const createApi = (baseUrl) => (endpoint, method) => 
  (params, config = {}) => request({
    url: `${baseUrl}/${endpoint}`,
    method,
    [method === 'get' ? 'params' : 'data']: params,
    ...config
  })